import { Link } from "react-router-dom";
import { RiArrowRightFill } from "react-icons/ri";
import BaseLabel from "@components/label/BaseLabel";
import TopbarStepIcon from "./TopbarStepIcon";
import { TopbarStep } from "@typedefs/interfaces";

interface StepLinkProps {
	step: TopbarStep;
	index: number;
	isActive: boolean;
	hasNext: boolean;
	statusName?: string;
	/** When set, navigates to this path (avoids fragile `..` resolution when the URL has fewer segments than expected). */
	absoluteTo?: string;
}

const StepLink = ({
	step,
	index,
	isActive,
	hasNext,
	statusName,
	absoluteTo,
}: StepLinkProps) => {
	const to = absoluteTo ?? `../${step.path}`;
	return (
		<Link
			to={to}
			{...(absoluteTo ? {} : { relative: "path" as const })}
			className="no-decoration"
			key={step.id}
		>
			<div className="d-flex h-100 align-items-center">
				<TopbarStepIcon 
					stepId={step.id} 
					isActive={isActive} 
					index={index} 
					statusName={statusName} 
				/>
				<BaseLabel 
					label={step.name} 
					className={`capitalize step-label ${isActive ? "ff-medium-ext" : "ff-normal-ext"}`} 
				/>
				{hasNext && <div className="ms-1"><RiArrowRightFill size={20} /></div>}
			</div>
		</Link>
	);
};

export default StepLink;
